
import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Route, Routes } from "react-router-dom";
import Api from "services/api"
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { setAddAppointmentPopup } from "slices/appointmentSlice";
import AppointmentView from "./appointment/view";
import { vendorAppointmentsSelector } from "slices/vendor/appointmentSlice";
import { fetchVendorAppointments } from "slices/vendor/appointmentSlice";
import { getBackgroundStyle } from "components/common/TableColor";
import moment from "moment";
import { useForm, Controller } from 'react-hook-form';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import DateRangeFilter from 'components/common/DateRangeFilter';
import { LegendButton, legends } from 'components/common/TableColor';
import { fetchVendorInterpreterOptions } from 'slices/interpreterSlice';

const apiService = new Api();

const appointmentRoutes = [
  {
    path: "",
    component: <AppointmentList />,
  },
  {
    path: "view/:id",
    component: <AppointmentView />,
  }
]

export const AppointmentRoutes = () => {

  return (
    <Routes>
      {appointmentRoutes.map(({ path, component }) => (
        <Route key={path} path={path} element={component} />
      ))}
    </Routes>
  )

}

function AppointmentList() {
  const dispatch = useDispatch()
  const { vendorAppointments: appointments, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(vendorAppointmentsSelector);
  const [filters, setFilters] = useState({});
  const [activeLegend, setActiveLegend] = useState(0);
  const [statusValue, setStatusValue] = useState("");
  const { control, handleSubmit, reset, getValues } = useForm({
    defaultValues: {
      start_date: null,
      end_date: null,
      appointment_id: "",
      interpreter: null,
      status: "",
    },
  });
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });

  useEffect(() => {
    dispatch(fetchVendorAppointments())
  }, [dispatch])

  // prefetch interpreter options
  useEffect(() => {
    (async () => {
      try {
        await dispatch(fetchVendorInterpreterOptions());
      } catch (e) {}
    })();
  }, [dispatch]);

  const handleAddAppointmentPopUp = (item) => {
    dispatch(setAddAppointmentPopup({
      show: true,
      item,
    }))
  };

  const handleActiveLegend = (id, value) => {
    setActiveLegend(id);
    setStatusValue(value);

    const values = getValues();
    const params = {
      start_date: values.start_date ? moment(values.start_date).format('YYYY-MM-DD') : null,
      end_date: values.end_date ? moment(values.end_date).format('YYYY-MM-DD') : null,
      appointment_id: values.appointment_id || "",
      interpreter: values.interpreter || "",
      status: value || "",
    };

    setFilters(params);
    dispatch(fetchVendorAppointments(1, params));
  };

  const handleReset = () => {
    reset({ start_date: null, end_date: null, appointment_id: "", interpreter: null, status: "" });
    setActiveLegend(null);
    setStatusValue("");
    setFilters({});
    dispatch(fetchVendorAppointments(1, {}));
  };

  const handleChange = (e) => {
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchVendorAppointments(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
          </div>
        </th>
        <th>
          <TableHeaderItem
            title="appid"
            sortBy="appid"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-1">
          <TableHeaderItem
            title="Language"
            sortBy="language"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-2">
          <TableHeaderItem
            title="Type"
            sortBy="type"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-1">
          <TableHeaderItem
            title="Status"
            sortBy="status"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-1">
          <TableHeaderItem
            title="Interpreter"
            sortBy="interpreter"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-2">
          <TableHeaderItem
            title="Meeting Date & time"
            sortBy="meeting_date"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-2">
          <TableHeaderItem
            title="School"
            sortBy="school"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {/* <th>
          <TableHeaderItem
            title="Service"
            sortBy="service"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title="Date"
            sortBy="date"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Language"
            sortBy="language"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Accounts"
            sortBy="accounts"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Interpreter"
            sortBy="interpreter"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-1">
          <TableHeaderItem
            title="Status"
            sortBy="status"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th> */}
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, appointments]);

  //#endregion

  const interpreters = useSelector((state) => state.interpreter.interpreter);
  const interpreterOptions = React.useMemo(
    () =>
      interpreters?.map((i) => ({
        value: i.id,
        label: i?.user?.name || i.name || 'Unknown',
      })) || [],
    [interpreters]
  );

  const interpreterLoadOptions = async (inputValue, loadedOptions, { page }) => {
    return await dispatch(
      fetchVendorInterpreterOptions(page, {
        pageLength: 10,
        sortBy: 'id',
        sortDirection: 'asc',
        search: inputValue,
      })
    );
  };


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      appointments && appointments?.map((appointment, index) => (
        <AppointmentItem appointment={appointment} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddAppointmentPopUp} current_page={current_page} pageLength={pageLength} />
      ))
    )
  }, [appointments, selectedItems, current_page]);

  //#endregion


  const filteredStatuses = React.useMemo(() => {
    const temp_array = [...legends];
    temp_array.unshift({
      value: "all",
      name: "All",
      id: 0,
      color: "#3176A0"
    });
    return temp_array;
  }, [legends]);

  return (
    <>
      <div style={{ margin: "84px 16px 0" }}>
        <div className="row_main_head">
          <h2 className="main_heading">Appointments</h2>
        </div>
        <div className="card_table">
          <div className="button-sm forLegends p-3 gap-1">
            <LegendButton
              activeId={activeLegend}
              options={filteredStatuses}
              handleClick={handleActiveLegend}
            />
          </div>
          <form
            onSubmit={handleSubmit((values) => {
              const params = {
                start_date: values.start_date ? moment(values.start_date).format('YYYY-MM-DD') : null,
                end_date: values.end_date ? moment(values.end_date).format('YYYY-MM-DD') : null,
                appointment_id: values.appointment_id || "",
                interpreter: values.interpreter || "",
                status: statusValue || "",
              };
              setFilters(params);
              dispatch(fetchVendorAppointments(1, params));
            })}
            className="search_form_ad"
          >
            <div className="row-primary dahboard_filter appointments">
              <DateRangeFilter control={control} />

              <div className="row-primary">
                <h2>Appointment ID</h2>
                <Controller
                  name="appointment_id"
                  control={control}
                  render={({ field }) => (
                    <div className="input-basis basic_bases">
                      <input
                        {...field}
                        type="text"
                        className="input-in type_inp"
                        placeholder="Enter ID"
                      />
                    </div>
                  )}
                />
              </div>

              <div className="row-primary" style={{ flexBasis: "40%" }}>
                <h2>Interpreter</h2>
                <div style={{ flex: 1 }}>
                  <Controller
                    name="interpreter"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <div className="basic_bases">
                        <AsyncPaginate
                          menuPlacement="auto"
                          styles={{ ...selectCustomStyles }}
                          value={
                            field.value
                              ? interpreterOptions.find(
                                  (opt) => String(opt.value) === String(field.value)
                                )
                              : null
                          }
                          loadOptions={interpreterLoadOptions}
                          isClearable
                          escapeClearsValue
                          onChange={(obj) => field.onChange(obj?.value ?? null)}
                          additional={{ page: 1 }}
                        />
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between px-3">
              <div className="row-primary row_10 w-100">
                <button type="submit" className="main_button  green">
                  Search
                </button>
                <button
                  type="button"
                  className="main_button  lightBlue"
                  onClick={handleReset}
                >
                  Reset
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ListLayout
        key={JSON.stringify(filters)}
        time={true}
        addButtonDisabled={true}
        title=""
        renderTableHeader={renderTableHeader}
        renderTableContent={renderTableContent}
        totalPages={totalPages}
        fetchList={fetchVendorAppointments}
        filtration={filters}
        selectedItems={selectedItems}
        refAddutton={refAddutton}
        addForm={addForm}
        searchTerm={searchTerm}
        className="appointment"
        setSearchTerm={setSearchTerm}
        loader={loader}
        searchPlaceholder="Search Appointments ..."
        noOfItems={total}
        refAddPopUp="#addAppointmentPopUp"
      >
      </ListLayout>
    </>
  )

}


const AppointmentItem = ({
  appointment, index, current_page, pageLength
}) => {

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);


  const statuses = [
    {
      label: "Available",
      value: "available",
    },
    {
      label: "Assigned",
      value: "assigned",
    }, {
      label: "DNC",
      value: "dnc",
    },
    {
      label: "CNC",
      value: "cnc",
    },
    {
      label: "Completed",
      value: "completed",
    },
    {
      label: "Cancelled",
      value: "cancelled",
    }
  ]

  const rawDatetime = appointment?.date + " " + appointment?.start_time;
  const formattedDate = moment(rawDatetime, 'YYYY-MM-DD HH:mm:ss').format('MMM D, YYYY HH:mm:ss');
  const typeLabels = {
    0: "Interpreting Request",
    1: "After Hours Request",
    2: "Bilingual Exams Request",
  };
  console.log('check appointment' ,appointment);
  return (
    <tr>
      <td style={getBackgroundStyle(appointment?.status)}>
        <div className="row_check">
          <span>{serial}</span>
        </div>
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        <Link className='link_preview' to={`/vendor/appointments/view/${appointment?.id}`}>
          {appointment?.appid}
        </Link>
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {/* {appointment?.language?.name || 'N/A'} */}
        {appointment?.language?.name || 'N/A'}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {typeLabels[appointment?.type] || ""}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.status}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {/* {appointment?.vendor_interpreter?.first_name + ' ' + appointment?.vendor_interpreter?.last_name || 'N/A'} */}
        {appointment?.vendor_interpreter ? `${appointment.vendor_interpreter.first_name}${appointment.vendor_interpreter.last_name ? ' ' + appointment.vendor_interpreter.last_name : ''}` : 'N/A'}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.date ? formattedDate : 'N/A'}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.school?.name || 'N/A'}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {moment((appointment.created_at), 'YYYY-MM-DD HH:mm').format('MMM D, YYYY HH:mm')}
      </td>
      {/* <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.accounts?.user?.name || 'N/A'}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.interpreter?.user?.name || 'N/A'}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {convertTimeToUTC(appointment.created_at)}
      </td>
      <td className="text-capitalize" style={getBackgroundStyle(appointment?.status)}>
        {appointment?.status}
      </td> */}
    </tr>
  )
}


export default AppointmentList;
